/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserGlobalGrantsDto } from '../../models/user-global-grants-dto';

export interface GetUserGlobalGrants$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getUserGlobalGrants(http: HttpClient, rootUrl: string, params: GetUserGlobalGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGlobalGrantsDto>> {
  const rb = new RequestBuilder(rootUrl, getUserGlobalGrants.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserGlobalGrantsDto>;
    })
  );
}

getUserGlobalGrants.PATH = '/api/users/{id}/global-grants';
